export default "__VITE_ASSET__CE5JL_6l__"